<template>
  <div class="drag-handle" :class="{ 'drag-handle__disabled': disabled }">
    <icon name="menu" class="drag-handle__icon" />
  </div>
</template>

<script>
export default {
  name: 'drag-handle',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../theme/variables.scss';

.drag-handle {
  display: inline-block;
  color: $global-muted-color;

  &, .drag-handle__icon {
    cursor: move;
  }

  &:hover, &:focus {
    color: $global-color;
  }
}

.drag-handle__disabled {
  opacity: 0.3;

  &, .drag-handle__icon {
    cursor: no-drop;
    pointer-events: none;
  }
}

</style>



// WEBPACK FOOTER //
// DragHandle.vue?339e5374